import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

const containerStyle = {
  padding: '1rem',
  maxWidth: '1200px',
  margin: '0 auto'
};

const headingStyle = {
  textAlign: 'center',
  marginBottom: '2rem',
  color: '#2c3e50'
};


const plansContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '1rem'
};

const planCardStyle = {
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  padding: '2rem',
  width: '223px',
  textAlign: 'center',
  transition: 'transform 0.3s ease',
  position: 'relative'
};

const planTitleStyle = {
  fontSize: '1.5rem',
  marginBottom: '1rem',
  color: '#2c3e50'
};

const priceContainerStyle = {
  margin: '1rem 0',
  position: 'relative'
};

const simplePriceStyle = {
  fontSize: '2rem',
  fontWeight: 'bold',
  color: '#3498db',
  margin: '1rem 0'
};

const originalPriceStyle = {
  fontSize: '1.2rem',
  color: '#999',
  textDecoration: 'line-through',
  marginRight: '0.5rem'
};

const discountBadgeStyle = {
  position: 'absolute',
  top: '-10px',
  right: '-10px',
  backgroundColor: '#e74c3c',
  color: 'white',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: '0.9rem'
};

const newPriceStyle = {
  fontSize: '2rem',
  fontWeight: 'bold',
  color: '#27ae60',
  marginTop: '0.5rem'
};

const featuresListStyle = {
  listStyle: 'none',
  padding: 0,
  textAlign: 'left',
  margin: '1.5rem 0'
};

const featureItemStyle = {
  padding: '0.5rem 0',
  borderBottom: '1px solid #eee'
};



const toggleButtonStyle = (active) => ({
  backgroundColor: active ? '#3498db' : '#bdc3c7',
  color: 'white',
  border: 'none',
  padding: '0.5rem 1rem',
  margin: '0 0.5rem',
  borderRadius: '4px',
  cursor: 'pointer'
});

const PricingPage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [language, setLanguage] = useState('en');

  const content = {
    choosePlan: { en: 'Choose Your Plan', hi: 'अपनी योजना चुनें' },
    getAccess: { en: 'Get access to all premium tests and features with our flexible subscription plans. Limited time Diwali offer - don\'t miss out!', hi: 'हमारी लचीली सदस्यता योजनाओं के साथ सभी प्रीमियम टेस्ट और सुविधाओं तक पहुँच प्राप्त करें। सीमित समय का दिवाली ऑफर - इसे मत छोड़ें!' },
    whyPremium: { en: 'Why Choose Premium?', hi: 'प्रीमियम क्यों चुनें?' },
    premiumDesc: { en: 'Premium members get access to exclusive content, advanced features, and priority support.', hi: 'प्रीमियम सदस्यों को विशेष सामग्री, उन्नत सुविधाओं और प्राथमिकता सहायता तक पहुँच मिलती है।' },
    alreadySubscribed: { en: 'Already Subscribed', hi: 'पहले से सब्सक्राइब्ड' }
  };

  const plans = [
    {
      id: 1,
      name: { en: '15 Days', hi: '15 दिन' },
      price: 149,
      duration: 0.5,
      isSimplePlan: true,
      features: [
        { en: 'Access to all premium tests', hi: 'सभी प्रीमियम टेस्ट तक पहुँच' },
        { en: 'Unlimited practice sessions', hi: 'असीमित अभ्यास सत्र' },
        { en: 'Performance analytics', hi: 'प्रदर्शन विश्लेषण' },
        { en: 'Priority support', hi: 'प्राथमिकता सहायता' }
      ]
    },
    {
      id: 2,
      name: { en: '1 Month', hi: '1 महीना' },
      originalPrice: 250,
      discountedPrice: 220,
      discountPercentage: 12,
      duration: 1,
      isSimplePlan: false,
      features: [
        { en: 'Access to all premium tests', hi: 'सभी प्रीमियम टेस्ट तक पहुँच' },
        { en: 'Unlimited practice sessions', hi: 'असीमित अभ्यास सत्र' },
        { en: 'Performance analytics', hi: 'प्रदर्शन विश्लेषण' },
        { en: 'Priority support', hi: 'प्राथमिकता सहायता' }
      ]
    },
    {
      id: 3,
      name: { en: '2 Months', hi: '2 महीने' },
      originalPrice: 450,
      discountedPrice: 349,
      discountPercentage: 22,
      duration: 2,
      isSimplePlan: false,
      features: [
        { en: 'Access to all premium tests', hi: 'सभी प्रीमियम टेस्ट तक पहुँच' },
        { en: 'Unlimited practice sessions', hi: 'असीमित अभ्यास सत्र' },
        { en: 'Performance analytics', hi: 'प्रदर्शन विश्लेषण' },
        { en: 'Priority support', hi: 'प्राथमिकता सहायता' },
        { en: '10% savings', hi: '10% बचत' }
      ]
    },
    {
      id: 4,
      name: { en: '3 Months', hi: '3 महीने' },
      originalPrice: 700,
      discountedPrice: 499,
      discountPercentage: 28,
      duration: 3,
      isSimplePlan: false,
      features: [
        { en: 'Access to all premium tests', hi: 'सभी प्रीमियम टेस्ट तक पहुँच' },
        { en: 'Unlimited practice sessions', hi: 'असीमित अभ्यास सत्र' },
        { en: 'Performance analytics', hi: 'प्रदर्शन विश्लेषण' },
        { en: 'Priority support', hi: 'प्राथमिकता सहायता' },
        { en: '28% savings', hi: '28% बचत' }
      ]
    }
  ];

  const getDiscountText = () => language === 'en' ? 'OFF' : 'छूट';

  const referContent = {
    title: { en: 'Refer and Earn', hi: 'रेफर और कमाएं' },
    benefitsTitle: { en: 'Benefits / लाभ', hi: 'लाभ / Benefits' },
    benefitsText: {
      en: 'Refer a friend and earn 10% reward on their payment. The new user gets 10% discount on their subscription.',
      hi: 'किसी मित्र को रेफर करें और उनके भुगतान पर 10% इनाम कमाएं। नया उपयोगकर्ता अपनी सदस्यता पर 10% छूट प्राप्त करता है।'
    },
    stepsTitle: { en: 'Steps to Refer / रेफर करने के चरण', hi: 'रेफर करने के चरण / Steps to Refer' },
    steps: [
      {
        en: 'Existing user will message the admin on WhatsApp number 7597838305  with the new admission number and name.',
        hi: 'मौजूदा उपयोगकर्ता 7597838305  व्हाट्सएप नंबर पर एडमिन को नया एडमिशन नंबर और नाम के साथ संदेश भेजेगा।'
      },
      {
        en: 'Then admin will acknowledge this.',
        hi: 'फिर एडमिन इसकी पुष्टि करेगा।'
      },
      {
        en: 'Once the new user wants to make the payment, it is 10% lesser payment they need to do.',
        hi: 'एक बार जब नया उपयोगकर्ता भुगतान करना चाहे, तो उन्हें 10% कम भुगतान करना होगा।'
      },
      {
        en: 'Admin will give the referring member 10% of the received amount.',
        hi: 'एडमिन रेफर करने वाले सदस्य को प्राप्त राशि का 10% देगा।'
      }
    ],
    contactText: {
      en: 'Contact admin for more details or to refer someone.',
      hi: 'अधिक जानकारी या किसी को रेफर करने के लिए एडमिन से संपर्क करें।'
    },
    icons: [
      { en: '💰 Earn 10%', hi: '💰 10% कमाएं' },
      { en: '🏷️ 10% Discount', hi: '🏷️ 10% छूट' },
      { en: '👥 Refer Friend', hi: '👥 मित्र को रेफर करें' },
      { en: '📱 Easy Process', hi: '📱 आसान प्रक्रिया' }
    ]
  };


  return (
    <div style={containerStyle}>
      <h3 style={headingStyle}>{content.choosePlan[language]}</h3>

      <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
        <button
          style={toggleButtonStyle(language === 'en')}
          onClick={() => setLanguage('en')}
        >
          English
        </button>
        <button
          style={toggleButtonStyle(language === 'hi')}
          onClick={() => setLanguage('hi')}
        >
          हिंदी
        </button>
      </div>

      <p style={{ textAlign: 'center' }}>
        {content.getAccess[language]}
      </p>
      <div style={{
        backgroundColor: '#f8f9fa',
      }}>


        <div style={containerStyle}>
          <h4 style={{
            textAlign: 'center',
            color: '#2c3e50',
            fontSize: '1.5rem'
          }}>
            {referContent.title[language]}
          </h4>

          <div className="benefits-grid" style={{
            display: 'grid',
            alignItems: 'start'
          }}>
            <div style={{
              backgroundColor: '#ffffff',
              padding: '1.5rem',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
            }}>
              <h4 style={{
                color: '#34495e',
                borderBottom: '2px solid #3498db',
                paddingBottom: '0.5rem',
                marginBottom: '1rem'
              }}>
                {referContent.benefitsTitle[language]}
              </h4>
              <p style={{
                fontSize: '1.1rem',
                lineHeight: '1.6',
                color: '#2c3e50',
                marginBottom: '1rem'
              }}>
                {referContent.benefitsText[language]}
              </p>

              <div style={{
                backgroundColor: '#ffffff',
                padding: '2rem',
                borderRadius: '12px',
              }}>
                <h4 style={{
                  color: '#34495e',
                  borderBottom: '2px solid #3498db',
                  paddingBottom: '0.5rem',
                  marginBottom: '1.5rem',
                  textAlign: 'center'
                }}>
                  {referContent.stepsTitle[language]}
                </h4>
                <ol style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.8',
                  color: '#2c3e50',
                  paddingLeft: '1.5rem'
                }}>
                  {referContent.steps.map((step, index) => (
                    <li key={index} style={{ marginBottom: '1rem' }}>
                      {step[language]}
                    </li>
                  ))}
                </ol>
              </div>

            </div>

          </div>

        </div>

        <style>{`
          @media (max-width: 768px) {
            .benefits-grid {
              grid-template-columns: 1fr !important;
              gap: '1rem' !important;
            }
            .icons-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              justify-items: center;
              gap: '0.5rem' !important;
            }
            h2 {
              font-size: 2rem !important;
            }
            .main-container {
              padding: '1rem' !important;
            }
          }
          @media (max-width: 480px) {
            .icons-grid {
              grid-template-columns: 1fr !important;
              gap: '0.5rem' !important;
            }
          }
        `}</style>
      </div>


      <div style={plansContainerStyle}>
        {plans.map((plan) => (
          <div
            key={plan.id}
            style={planCardStyle}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <h2 style={planTitleStyle}>{plan.name[language]}</h2>

            {plan.isSimplePlan ? (
              <div style={simplePriceStyle}>₹{plan.price}</div>
            ) : (
              <div style={priceContainerStyle}>
                <span style={originalPriceStyle}>₹{plan.originalPrice}</span>
                <div style={discountBadgeStyle}>{plan.discountPercentage}% {getDiscountText()}</div>
                <div style={newPriceStyle}>₹{plan.discountedPrice}</div>
              </div>
            )}

            <ul style={featuresListStyle}>
              {plan.features.map((feature, index) => (
                <li key={index} style={featureItemStyle}>✓ {feature[language]}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>


    </div>
  );
};

export default PricingPage;
